// extracted by mini-css-extract-plugin
export default {"grey":"_1m4O88WtLGGFzUWJXwVk1l"};